// Node
import i18next from 'i18next';

// Custom
import $ from 'jquery';
import i18CustomParams from 'new_design/common/i18_custom';
import DatePicker from 'new_design/common/search_widget/date-picker';
import GuestsWidget from 'new_design/common/search_widget/guests';
import SearchForm from 'new_design/common/search_widget/search_form/common';
import SearchString from 'new_design/common/search_widget/search_string';
import GuestsWidgetMobile from '../../../mobile/common/search_widget/guests_mobile';

class GlobalForm extends SearchForm {
  static async init(formId, options = {}) {
    let form = new GlobalForm(formId);
    await form.init(options);
    return form;
  }

  constructor(formId) {
    super(formId);
    i18next.init(i18CustomParams(), function (err, t) {});

    this.$submitBtn = this.$form.find('#search_button');
    this.$resetBtn = this.$form.find('#reset_search_data');

    this.searchString = new SearchString(formId, {
      searchStringBase: 'search_string_base',
      searchString: 'search_string',
      searchType: 'search_type',
      searchId: 'search_id',
      without_submit: $(`form#${formId}`).data('without_submit'),
    });
    window.searchString = this.searchString;
    this.datePicker = new DatePicker(formId, {
      dateStart: '#date_start',
      dateEnd: '#date_end',
      dateRange: '#dates',
      nightsCount: '#nights_count',
      firstPreview: false,
    });
    if (window.isMobileDevice) {
      this.guestsWidget = new GuestsWidgetMobile('#search-guest', {
        childrenAges: '.children_ages',
        childrenCount: '.children_count',
        countGuests: '.count_guests',
        guestChildNumber: '.guest-child-number',
        totalAdultsCount: '.total_adults_count',
        totalChildrenCount: '.total_children_count',
      });
    } else {
      this.guestsWidget = new GuestsWidget(formId, {
        childrenAges: 'children_ages',
        childrenCount: 'children_count',
        countGuests: 'count_guests',
        guestChildNumber: 'guest-child-number',
        totalAdultsCount: 'total_adults_count',
        totalChildrenCount: 'total_children_count',
        withPetCheckbox: 'with_pet',
      });
    }

    window.globalForm = {
      datePicker: this.datePicker,
      guestsWidget: this.guestsWidget,
    };
  }

  // private

  async init(options = {}) {
    let search_data = await SearchForm.getSearchData();

    const project = this.$form.data('project');

    const tabSearchType = options.PROJECT_TO_TAB_SEARCH_TYPE?.[project] ?? 'all';
    const placeholderText =
      options.PROJECT_PLACEHOLDERS?.[project] ??
      options.TAB_SEARCH_TYPES_PLACEHOLDERS?.[tabSearchType] ??
      'Название объекта или региона';

    let searchFormBasePlaceHolder;

    if (search_data.search_string) {
      searchFormBasePlaceHolder = search_data.search_string;
      this.$form.find('#search_string_base').removeClass('search-params-popup__string_placeholder');
    } else {
      searchFormBasePlaceHolder = placeholderText;
      this.$form.find('#search_string_base').addClass('search-params-popup__string_placeholder');
    }

    this.$form.find('#dates').val(search_data.dates_range_printable);
    this.$form.find('.dates_mobile_input').val(search_data.dates_range_printable);
    this.$form.find('#total_adults_count').val(search_data.adults_count);
    this.$form.find('#total_children_count').val(search_data.children_count);
    this.$form.find('#children_count').val(search_data.children_count);
    this.$form.find('#children_count_numb').html(search_data.children_count);
    this.$form.find('#count_guests').val(search_data.adults_count);
    this.$form.find('#count_guests_numb').html(search_data.adults_count);
    this.$form.find('#children_ages').data('ages', search_data.children_ages);
    $('#search-guest').find('#children_count_numb').html(search_data.children_count);
    $('#search-guest').find('#count_guests_numb').html(search_data.adults_count);
    this.$form.find('#search_string').val(search_data.search_string);
    this.$form.find('#search_string_base').html(searchFormBasePlaceHolder);
    this.$form.find('#search_id').val(search_data.search_id);
    this.$form.find('#old_search_id').val(search_data.search_id);
    this.$form.find('#search_type').val(search_data.search_type);
    this.$form.find('#date_start').val(search_data.date_start);
    this.$form.find('#filter_date_start').val(search_data.date_start);
    this.$form.find('#date_end').val(search_data.date_end);
    this.$form.find('#filter_date_end').val(search_data.date_end);
    this.$form.find('#camp_treatment_profiles_input').val(search_data.camp_treatment_profiles);
    this.$form
      .find(`#camp_treatment_profiles option[value='${search_data.camp_treatment_profiles}']`)
      .attr('selected', true);
    if (this.$form.find('#search_type').val() !== 'camp')
      this.$form.find('#old_search_type').val(search_data.search_type);
    if (search_data.children_count > 0) {
      $('#search-guest').find('#guest-child-title').removeClass('hidden').show();
      this.$form.find('#guest-child-title').removeClass('hidden').show();
    }
    if (search_data.our_stuff) {
      this.$form.find('#reset_search_data').removeClass('hidden');
      this.$form.find('#apartments_reset_search_data').removeClass('hidden');
      this.$form.find('#apartments_load_from_travel_line').removeClass('hidden');
    }
    const withPet = search_data.with_pet;
    if (withPet) this.$form.find('#with_pet_string').removeClass('hidden');
    this.$form.find('#with_pet').prop('checked', withPet);
    this.$form.find('.with_pet_input').prop('checked', withPet);
    this.$form.find('.switch__input').toggleClass('switch__input-checked', !!withPet);

    super._init();

    this.searchString.init();
    this.datePicker.init();
    this.guestsWidget.init();
    this._eventsInit();
    this._metrikaInit();
    this._openTypeheadOnOpenModal();
  }

  _openTypeheadOnOpenModal() {
    $(() => {
      $('.open_popup[rel="search-name"]').click(() => {
        setTimeout(() => {
          window.searchString.open();
        }, 50);
      });
    });
  }

  _eventsInit() {
    let searchInput = this.$form.find('.search-item input'),
      nameInput = this.$form.find('.search-item__name input'),
      nameWindow = this.$form.find('.name'),
      guestInput = this.$form.find('.search-item__guest'),
      guestWindow = this.$form.find('.guest'),
      btnCloseDate = this.$form.find('.search-drop .date-btn__item_left');

    const handleWindowSwitch = (input, window, areaClick) => {
      input.on('click', (e) => {
        window.fadeIn();
      });
      searchInput.not(input).on('focus', (e) => {
        window.fadeOut();
      });
      btnCloseDate.on('click', (e) => {
        e.stopPropagation();
        window.fadeOut();
      });
      if (areaClick) {
        $(document).on('mouseup', (e) => {
          if (!window.is(e.target) && window.has(e.target).length === 0 && !input.is(e.target)) {
            window.fadeOut();
          }
        });
      }
    };

    handleWindowSwitch(nameInput, nameWindow, true);
    handleWindowSwitch(guestInput, guestWindow, true);

    this.$resetBtn.on('click', () => {
      this.$resetBtn.prop('disabled', true);
      this.$submitBtn.prop('disabled', true);
      this.reset();
    });
  }

  _metrikaInit() {
    this.$form.on('submit', () => {
      window.ymReachGoal('search-button-metrika');
    });
  }
}

export default GlobalForm;
